import React from 'react';
import { Field } from '../../../headless/field';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicFileUploadProps } from '../../../types/public-props';
import { Label } from './label';
import { Error } from './error';
import { Description } from './description';
import { ButtonInput } from './button-input';

export interface FileUploadProps {
  children: React.ReactNode;
  asChild?: boolean;
  className?: string;
}

const Root = React.forwardRef<HTMLDivElement, FileUploadProps>((props, ref) => {
  const { children, asChild, className } = props;
  const { id } = useFieldProps<PublicFileUploadProps>();

  return (
    <Field ref={ref} id={id} asChild={asChild} className={className}>
      <Field.InputWrapper>
        <Field.Input>{children}</Field.Input>
      </Field.InputWrapper>
    </Field>
  );
});

Root.displayName = 'FileUpload';

interface FileUploadComponent
  extends React.ForwardRefExoticComponent<
    FileUploadProps & React.RefAttributes<HTMLDivElement>
  > {
  Label: typeof Label;
  Error: typeof Error;
  Description: typeof Description;
  ButtonInput: typeof ButtonInput;
}

export const FileUpload = Root as FileUploadComponent;
FileUpload.Label = Label;
FileUpload.Error = Error;
FileUpload.Description = Description;
FileUpload.ButtonInput = ButtonInput;
